import React from 'react';
import {DialogOverlay, DialogContent} from '@reach/dialog';
import {animated, useTransition} from 'react-spring';

import * as styles from './Modal.module.css';

const AnimatedDialogOverlay = animated(DialogOverlay);
const AnimatedDialogContent = animated(DialogContent);

export function Modal({show, onDismiss, children}) {
  const transitions = useTransition(show, null, {
    from: {opacity: 0, y: -20},
    enter: {opacity: 1, y: 0},
    leave: {opacity: 0, y: -20},
    config: {duration: 100},
  });

  return transitions.map(({item: open, key, props: {opacity, y}}) => (
    <AnimatedDialogOverlay
      key={key}
      style={{opacity}}
      onDismiss={onDismiss}
      isOpen={open}
    >
      <AnimatedDialogContent
        className={styles.Dialog}
        style={{transform: y.interpolate(y => `translate3d(0px, ${y}px, 0px)`)}}
      >
        {children}
      </AnimatedDialogContent>
    </AnimatedDialogOverlay>
  ));
}
